import React, { useMemo, useState, useEffect } from 'react';
import { Table } from 'reactstrap';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import MagnifyIcon from 'mdi-react/MagnifyIcon';
import Api from '../../util/api';
import Pagination from '../../shared/components/pagination/Pagination';
import { partial } from '../../util/translation/translation';

const s = partial('shared');

const TeamAdminListPage = () => {
  const [teams, setTeams] = useState({ data: [] });
  const [searchText, setSearchText] = useState('');
  const fetchTeams = async (page) => {
    try {
      const { data } = await Api.clubadmin.teams.all(page);
      setTeams(data);
    } catch (e) {
      toast.error(e || s('somethingWentWrong'));
    }
  };

  // Filters only the currently loaded page of teams - the list endpoint is
  // server-paginated and has no search parameter.
  const filteredTeams = useMemo(() => {
    if (!searchText) {
      return teams.data;
    }
    const search = searchText.toLowerCase();
    return teams.data.filter((team) =>
      team.team_name?.toLowerCase().includes(search)
    );
  }, [teams.data, searchText]);

  const renderTeams = (_teams) =>
    _teams.map((team) => (
      <tr key={`teams:${team.team_id}`}>
        <td>
          <Link to={`/clubadmin/team/edit/${team.team_id}`}>
            {team.team_name}
          </Link>
        </td>
        <td>{team.team_shortName}</td>
        <td>{team.team_externalProviderId}</td>
        <td>
          {team.team_logoUrl ? (
            <img alt="team logo" src={team.team_logoUrl} />
          ) : (
            'Missing logo'
          )}
        </td>
      </tr>
    ));

  useEffect(() => {
    fetchTeams();
  }, []);
  return (
    <>
      <div className="flex justify-content-end mb-2">
        <div className="form">
          <div className="form__form-group products-list__search">
            <input
              placeholder={s('search')}
              value={searchText}
              onChange={(event) => setSearchText(event.target.value)}
              name="search"
              className="rounded"
            />
            <MagnifyIcon />
          </div>
        </div>
      </div>
      <Pagination
        rowsPerPage={[100, 250, 500]}
        items={teams.total || 0}
        onChangePage={fetchTeams}
      />
      <Table responsive bordered striped>
        <thead>
          <tr>
            <th>Name</th>
            <th>Short name</th>
            <th>ExternalId</th>
            <th>Logo</th>
          </tr>
        </thead>
        <tbody>{renderTeams(filteredTeams)}</tbody>
      </Table>
      <Pagination
        rowsPerPage={[100, 250, 500]}
        items={teams.total || 0}
        onChangePage={fetchTeams}
      />
    </>
  );
};

export default TeamAdminListPage;
